import { Festival } from './festival.interface';
import { Product } from './product.interface';

export interface Discount {
  id?: number;
  festival_id?: number;
  title: string;
  active: boolean | number;
  product_id?: number;
  discount_items?: DiscountItem[];
  festival?: Festival;
  product?: Product;
}

export interface DiscountItem {
  id: number;
  price: number;
  amount: number;
}
